module.exports = __webpack_public_path__ + "static/img/paintwr.42e48e87.webp";